import { type UserStore } from "@store/auth/user.store";

export const isAutopilot = (user: UserStore) => user.user?.autopilot;
